import { TOGGLE_LEFT1_PANEL, TOGGLE_RIGHT2_PANEL, ToggleLeft1Panel } from "./types";
import { createAction } from "@reduxjs/toolkit";
import { ToggleRight2Panel } from "./types";

export const toggleRight2Panel = createAction<ToggleRight2Panel["payload"]>(TOGGLE_RIGHT2_PANEL);

export const toggleLeft1Panel = createAction<ToggleLeft1Panel["payload"]>(TOGGLE_LEFT1_PANEL);
